<article
  [class.is-clickable]="!isNotClickable()"
  [class.is-fullheight]="isFullheight()"
  class="is-fullwidth box is-flex is-flex-direction-column is-align-items-center"
>
  <div class="is-fullwidth is-flex is-justify-content-center mb-5 mt-5">
    <fino-icon
      [icon]="icon()"
      [src]="iconSrc()"
      class="tile-icon"
      [styles]="iconStyles()"
      [ngClass]="iconClass()"
    ></fino-icon>
    @if (hasActiveIndicator()) {
      <span
        class="active-indicator"
        [class.has-background-success]="active()"
        [class.has-background-danger]="!active()"
      ></span>
    }
  </div>

  <app-header
    isCentered
    titleClass="is-size-5"
    subtitleClass="is-size-6 p-2"
    [header]="header()"
    [subHeader]="subHeader()"
    class="mb-5"
  ></app-header>

  @if (!hideCtaButton()) {
    <button
      [primary]="true"
      type="button"
      (click)="ctaClicked()"
      [loading]="isLoading()"
      fino-button
      [label]="ctaLabel()"
    ></button>
  }

  <div class="content is-fullwidth">
    <ng-content></ng-content>
  </div>
</article>
